<template>
	<div class="rules">
		<h3>{{$t('getCardSuccess.rules_title')}}</h3>
		<ul>
			<li v-for="it in $t('getCardSuccess.rules')" v-html="it"></li>
		</ul>
	</div>
</template>
 
<script>
export default {
  name: 'banner',
  methods: {
  	changeLang (val) {
  		//console.log(this.$i18n.locale);
  		this.$i18n.locale = val
  	}
  },
  
}
</script>
<style scoped lang="less">
@media (min-width:768px) {/*pc*/
	.rules{
		padding: 0 0 50px;
		color: #666;
		h3{
			font-size: 14px;
			color: #333;
			line-height: 14px;
			margin-bottom: 20px;
		}
		h3:after{
			content: "";
			display: inline-block;
			vertical-align: middle;
			width: calc(100% - 66px);
			margin-left: 10px;
			height: 10px;
			background: url(../../static/images/rule-title-bg.png) repeat;
		}
		li{
			line-height: 20px;
		}
		li:nth-child(5){
			overflow: hidden;
		}
	}
}
@media (max-width:768px) {/*mobile*/
	.rules{
		padding-bottom: 20px;
		margin-top: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/rules.vue